module.exports = __webpack_public_path__ + "img/Ele5.2d291b20.jpg";